export interface Styles {
  variables: {
    [key: string]: string | number
  }
  rules: {
    [key: string]: {
      [key: string]: string
    }
  }
}
